// @flow

import styled from 'styled-components';
import {
  grid, gridTemplateColumns, gridTemplateRows, gridArea,
} from '../../../helpers/gridHelpers';
import {
  ContentWrapper,
  Title as DefaultTitle,
  Description,
} from '../components';
import type { Theme } from '../../../types';

export const Container = styled<any, Theme>('section')`
  ${grid()}
  ${gridTemplateColumns('8.25rem 1fr')}
  ${gridTemplateRows('8.25rem auto')}
  height: 100%;
`;

export const Icon = styled<any, Theme>('header')`
  ${gridArea('1 / 1 / 2 / 2')}
  border: .5rem solid white;
  border-radius: 50%;

  height: calc(100% - 1rem);
  width: calc(100% - 1rem);

  > div {
    height: 100%;
    width: 100%;
  }
`;

export const Title = styled<typeof DefaultTitle, Theme>(DefaultTitle)`
  padding-bottom: .5rem;
`;

export const ButtonWrapper = styled<any, Theme>('footer')`
  justify-self: flex-end;
  margin: 1.25em 0 0;
`;

export const Content = styled<typeof ContentWrapper, Theme>(ContentWrapper)`
  ${gridArea('1 / 2 / 3 / 3')}
  padding-left: 1rem;
`;

export {
  Description,
};

export default null;
